<template>
	<div class="position-absolute w-100 fixed-bottom">
		<div class="bg-black">
			<div class="container p-md-5 p-4 text-light">
				<div class="row">
					<div class="col-md-2 col-6 offset-md-3 text-center">
						<ul class="list p-0 m-0">
							<router-link to="/" tag="li">
								<a class="link text-decoration-none">{{ $t("navbar.home") }}</a>
							</router-link>
							<router-link :to="lang == 'hu' ? '/rolunk':'/about'" tag="li">
								<a class="link text-decoration-none">{{ $t("navbar.about") }}</a>
							</router-link>
							<router-link :to="lang == 'hu' ? '/ijaszpalya':'/archery-range'" tag="li">
								<a class="link text-decoration-none">{{ $t("navbar.field") }}</a>
							</router-link>
							<!--<router-link :to="lang == 'hu' ? '/termekeink':'/products'" tag="li">
								<a class="link">{{ $t("navbar.products") }}</a>
							</router-link>-->
						</ul>
					</div>
					<div class="col-md-2 d-none d-md-block text-center">
						<a href="/">
							<img src="../assets/img/csoda.png" draggable="false" class="img-fluid" style="width: 50px;">
						</a>
					</div>
					<div class="col-md-2 col-6 text-center">
						<ul class="list p-0 m-0">
							<router-link :to="lang == 'hu' ? '/hirek':'/news'" tag="li">
								<a class="link text-decoration-none">{{ $t("navbar.news") }}</a>
							</router-link>
							<router-link :to="lang == 'hu' ? '/egyesulet':'/association'" tag="li">
								<a class="link text-decoration-none">{{ $t("navbar.club") }}</a>
							</router-link>
							<router-link :to="lang == 'hu' ? '/kapcsolat':'/contact'" tag="li">
								<a class="link text-decoration-none">{{ $t("navbar.contact") }}</a>
							</router-link>
						</ul>
					</div>
					<div class="col-12 w-100 my-4" style="border-top: 1px solid white;"></div>
					<div class="col-12 text-center">
						<ul class="list p-0 m-0 d-inline-flex">
							<li class="footer-link-circle">
								<a href="https://www.facebook.com/csodaszarvasbarlang/" target="_blank" class="text-white d-block">
									<i class="fa fa-facebook"></i>
								</a>
							</li>
							<li class="footer-link-circle">
								<a href="https://www.instagram.com/csodaszarvas_ijaszbarlang/" target="_blank" class="text-white d-block">
									<i class="fa fa-instagram"></i>
								</a>
							</li>
							<li class="footer-link-circle">
								<a href="tel:+36703121117" target="_blank" class="text-white d-block">
									<i class="fa fa-phone"></i>
								</a>
							</li>
							<li class="footer-link-circle">
								<a href="https://goo.gl/maps/NAAMzi59R6Dzf6Pz8" target="_blank" class="text-white d-block">
									<i class="fa fa-map-marker"></i>
								</a>
							</li>
							<li class="footer-link-circle">
								<a href="mailto:info@ijaszat.eu" target="_blank" class="text-white d-block">
									<i class="fa fa-envelope-o"></i>
								</a>
							</li>
						</ul>
						<div class="text-center text-white w-100 mt-3">
							<p>{{ $t("contact.subtext") }}</p>
							<p style="margin: 0;">2024 © Copyright. {{ $t("footer.reserved") }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { Bus }  from "../bus.js";

	export default {
		data: function(){
            return {
                lang: ""
            }
        },
        created: function(){
            this.lang = this.$i18n.locale;
        },
        mounted: function(){
            var self = this;
            Bus.$on("lang", (lang) => {
                if(lang === "hu"){
                    self.lang = "hu";
                }else{
                    self.lang = "en";
                }
            });
        },
        methods: {
			sendData: function(typeHU, typeEN, titleHU, titleEN){
				Bus.$emit("type", typeHU, typeEN, titleHU, titleEN);
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/Footer.vue